import {isString} from 'lodash';

import mainConfig from 'mainConfig';
import requester from 'Services/requester/requester';
import styleCopy from '../style/styleCopy';

const TOMTOM_ORIGIN = 'api.tomtom.com';

class TierStyleRetriever {
    constructor() {
        this._cache = {};
    }

    _getOrigin = () => mainConfig.origin;

    _transformResponse = (response) => {
        return JSON.parse(response.replace(new RegExp(TOMTOM_ORIGIN, 'g'), this._getOrigin()));
    }

    _download = (styleUrl) => {
        const options = {url: styleUrl};
        return requester.get(options, this._transformResponse);
    };

    fetch = async (tier) => {
        const styleUrl = tier.getStyle();
        if (!isString(styleUrl)) {
            tier.setStyle(styleUrl);
            return tier;
        }

        let style = this._cache[styleUrl];
        if (!style) {
            style = await this._download(styleUrl);
            this._cache[styleUrl] = style;
        }

        tier.setStyle(styleCopy(style));
        return tier;
    };
}

export default () => {
    return new TierStyleRetriever();
};



// WEBPACK FOOTER //
// ./map/map/tierStyleRetriever.js